import React from 'react';

import { PlaceholderSize } from 'modules/shared/types';
import { TitleBlocLoader } from '../../components';

import styles from './introduction-component.module.css';

export const IntroductionLoader: React.FC<{ placeholderSize?: PlaceholderSize; largeLegend?: boolean }> = React.memo(
    ({ placeholderSize, largeLegend = false }) => {
        return (
            <div className={`${styles.root}`}>
                <TitleBlocLoader size={placeholderSize} largeLegend={largeLegend} />
            </div>
        );
    },
);

export const IntroductionLoaderBuilder = (props: {
    placeholderSize?: PlaceholderSize;
    largeLegend?: boolean;
}): React.ReactNode => {
    const { placeholderSize, largeLegend } = props;
    return <IntroductionLoader placeholderSize={placeholderSize} largeLegend={largeLegend} />;
};
